import * as React from 'react';
import Loader from '../Loader';
import Select from 'antd/lib/select';
import { CommonProps } from './common.intefaces';
import { useDebounce } from 'src/hooks/useDebounce';
import { SEARCH_TIMEOUT } from 'src/Library/Constants';
import { Product } from 'src/components/pages/masters/Product/Product.interface';
import { searchProduct } from 'src/components/pages/masters/Product/Product.api';

interface IProps extends CommonProps {
  apiOptions?: ProductApiParams;
  renderDropdown?: (menu: React.ReactElement) => React.ReactElement;
}

interface ProductApiParams {
}

const ProductSelect = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    apiOptions,
    placeholder,
    renderDropdown,
  } = props;

  const [products, setProducts] = React.useState<Product[]>([]);
  const [searching, setSearching] = React.useState<boolean>(false);
  const [queryString, setQuery] = React.useState<string>('');

  const handleProductSearch = async () => {
    setSearching(true);
    const response = await searchProduct({
      searchQuery: queryString,
      ...apiOptions,
    });
    setProducts(response?.data || []);
    setSearching(false);
  };

  const debounceTime = useDebounce(queryString, SEARCH_TIMEOUT);
  React.useEffect(() => {
    setSearching(true);
    handleProductSearch();
  }, [debounceTime]);

  const dropdownRender = (menu) => {
    if (searching) return <div
      style={{ padding: '25px' }}>
      <Loader />
    </div>;
    if (renderDropdown) {
      return renderDropdown(menu);
    }
    return menu;
  };

  const renderProductOptions = () => {
    return products?.map((product: Product) => <Select.Option
      {...product}
      key={product.id}
    >
      {product.internalName} {product?.status === 'ACTIVE' ? '' : '(Inactive)'}
    </Select.Option>) || [];
  };

  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    labelInValue
    value={value}
    disabled={disabled}
    onChange={onChange}
    className={className}
    mode={mode || 'default'}
    dropdownRender={dropdownRender}
    dropdownMatchSelectWidth={false}
    onSearch={query => setQuery(query)}
    onFocus={() => handleProductSearch()}
    filterOption={(inputValue, option) => true}
    placeholder={placeholder || 'Select Product(s)'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderProductOptions()}
  </Select>;
};

export default React.memo(ProductSelect);
